import React from 'react'
import BottomNav from './BottomNav'
// import ExpansionPanel from './ExpansionPanel'
import Main from '../Main/'

const MobileForm = ({ mobile, inbox, dialog, contactID }) => (
  <div>
    <Main inbox={inbox} mobile={mobile} dialog={dialog} contactID={contactID} />
    {/* <ExpansionPanel mobile={mobile} /> */}
    <BottomNav inbox={inbox} mobile={mobile} dialog={dialog} />
  </div>
)

export default MobileForm
